import React from 'react';
import BasicModal from "components/common/BasicModal";
import { Checkbox, Container, Dropdown, Label, TextArea } from 'semantic-ui-react';

export default class RejectionModal extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      rejectionReason: '',
      message: '',
      silentRejection: false
    };

    this.rejectionOptions = [
      {
        text: 'PROGRAM NOT YET STARTED',
        value: 'PROGRAM_NOT_YET_STARTED',
        message: "We're sorry, but this program has not started yet!"
      },
      {
        text: 'PROGRAM ENDED',
        value: 'PROGRAM_ENDED',
        message: "We’re sorry, but the deadline to submit a receipt has passed. Thank you for your participation!"
      },
      {
        text: 'ALREADY QUALIFIED',
        value: 'ALREADY_QUALIFIED',
        message: "Our records show that you have already submitted this receipt, and it has already been accepted as valid. "
      },
      {
        text: 'DUPLICATE IMAGE',
        value: 'DUPLICATE_IMAGE',
        message: "Your receipt seems to be a duplicate of an existing submission or is invalid."
      },
      {
        text: 'RECEIPT UNREADABLE',
        value: 'RECEIPT_UNREADABLE',
        message: "We can't read your receipt. Be sure it's in focus, well lit, and the entire receipt is visible, including store, items purchased, and purchase date."
      },
      {
        text: 'INVALID PURCHASE DATE',
        value: 'INVALID PURCHASE DATE',
        message: "Your purchase was not made within the program start and end dates, so your receipt does not qualify."
      },
      {
        text: 'MISSING PURCHASE DATE',
        value: 'MISSING_PURCHASE_DATE',
        message: "Your purchase must be completed within the program start and end dates; please resubmit your receipt with the purchase date clearly visible."
      },
      {
        text: 'MULTIPLE RECEIPTS IN PHOTO',
        value: 'MULTIPLE_RECEIPTS_IN_PHOTO',
        message: "Your photo contains more than one receipt. Please ensure your upload only includes image(s) of one receipt."
      }, 
      {
        text: 'REQUIRED PRODUCT NOT PURCHASED',
        value: 'REQUIRED PRODUCT NOT PURCHASED',
        message: "We’re sorry, but your receipt does not contain a qualifying purchase."
      },           
      {
        text: 'INELIGIBLE RETAILER',
        value: 'INELIGIBLE RETAILER',
        message: "Your receipt contains purchases from a non-participating retailer, and does not qualify. "
      },        
      {
        text: 'Other',
        value: 'OTHER',
        message: ""
      },
    ]


  }

  toggleSilentRejection = () => this.setState((prevState) => ({ silentRejection: !prevState.silentRejection }))

  onRejectionSelection = (e, data) => {
    // console.log(data);

    var found = this.rejectionOptions.find(function(element) {
      return element.value == data.value;
    });

    this.setState({
      rejectionReason: data.value,
      message: found.message
    })

  }

  onMessageChange = (e, data) => {
    this.setState({
      message: data.value
    })
  }

  onRejectionButtonClicked = (e) => {

    if (this.state.rejectionReason != '') {
      this.props.handleReject(this.state.rejectionReason, this.state.message, this.state.silentRejection);
    }

  }

  canSubmit = () => {
    console.log(this.state.rejectionReason);
    return (this.state.rejectionReason == '')
  }


    render() {


      return (
        <BasicModal
          header="Reject this item"
          specialType="primary-modal db-create-break-modal fadeInUp animResponse"
          dimmer='inverted'
          modalSize="small"
          scrolling={false} 
          actions={[
            {
              label: "Reject",
              action: this.onRejectionButtonClicked,
              displayType: "button",
              primaryCheck: true,
              isDisabled: (this.state.rejectionReason == '')
            }
          ]}
          open={this.props.modalOpen}
          onClose={this.props.handleClose }>

            <Container>
              <p>Select Rejection Reason</p>
              <Dropdown
                  placeholder='Rejection Reason'
                  options={this.rejectionOptions}
                  value={this.state.rejectionReason}
                  onChange={this.onRejectionSelection}
                  selection
                  closeOnBlur
                  closeOnChange
                  openOnFocus={false}
                  selectOnBlur={false}
                  selectOnNavigation={false} />

            <p></p>

            <p>This rejection message will be sent to the user:</p>
            <TextArea
              placeholder=""
              value={this.state.message}
              onChange={this.onMessageChange}
              />

              <Checkbox className='inline-checkbox'
                        label="Silent - reject without sending email"
                        onChange={this.toggleSilentRejection}
                        checked={this.state.silentRejection}
                        />

            </Container>
              <p>

              </p>

        </BasicModal>
      );
    }
  };
  


// WEBPACK FOOTER //
// ./public/pages/UGCModeration/RejectionModal.jsx